import { useEffect, ReactNode } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Tabs } from '../../atoms/tabs'

type TabbedViewProps = {
  defaultId: string
  validIds: string[]
  children: ReactNode
  className?: string
}

export const TabbedView = ({
  defaultId,
  validIds,
  children,
  className,
}: TabbedViewProps) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabParam = searchParams.get('tab')
  const activeId =
    tabParam && validIds.includes(tabParam) ? tabParam : defaultId

  useEffect(() => {
    if (!tabParam || !validIds.includes(tabParam)) {
      setSearchParams({ tab: defaultId }, { replace: true })
    }
  }, [tabParam, validIds, defaultId, setSearchParams])

  return (
    <Tabs
      value={activeId}
      onValueChange={(value) =>
        setSearchParams({ tab: value }, { replace: true })
      }
      className={className}
    >
      {children}
    </Tabs>
  )
}
